import React from 'react';
import { LogListWidget } from '../../widgets/LogListWidget';

const LoggerPage = () => {

    return (
        <div style={{
            display: 'flex',
            justifyContent: "center",
            height: "90%"
        }}>
            <LogListWidget />
        </div>
    );
};

export default LoggerPage;